var map = {
	"./2-1.png": "d4bc",
	"./2-2.png": "6f38",
	"./2-3.png": "e98f",
	"./2-4.png": "481f",
	"./2-5.png": "9783",
	"./2-6.png": "4668",
	"./2-7.png": "4214",
	"./2-8.png": "83f9",
	"./2-9.png": "741a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "350c";